export {ClubTileModule} from './club-tile.module';
export {ClubTileComponent} from './club-tile.component';
